import React from 'react';
import { Clipboard } from '@atlaskit/media-picker';
import PickerFacadeProvider from './PickerFacadeProvider';
export var ClipboardWrapper = function ClipboardWrapper(_ref) {
  var mediaState = _ref.mediaState,
    featureFlags = _ref.featureFlags,
    container = _ref.container;
  return /*#__PURE__*/React.createElement(PickerFacadeProvider, {
    mediaState: mediaState,
    analyticsName: "clipboard"
  }, function (_ref2) {
    var mediaClientConfig = _ref2.mediaClientConfig,
      config = _ref2.config,
      pickerFacadeInstance = _ref2.pickerFacadeInstance;
    var clipboardConfig = Object.assign({}, config);
    clipboardConfig.container = container;
    clipboardConfig.onPaste = function (event) {
      event.stopPropagation();
      return false;
    };
    return /*#__PURE__*/React.createElement(Clipboard, {
      mediaClientConfig: mediaClientConfig,
      config: clipboardConfig,
      onError: pickerFacadeInstance.handleUploadError,
      onPreviewUpdate: pickerFacadeInstance.handleUploadPreviewUpdate,
      onEnd: pickerFacadeInstance.handleReady,
      featureFlags: featureFlags
    });
  });
};